import ApiConstants from "../../../../../../utils/apiConstants";
import { axiosPatch } from "../../../../../../packages/apiPackage/axiosRequest";

async function UpdateShortIntroduction({ setBtnLoading, btnLoading, editionId, content }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            await axiosPatch({
                endpoint: ApiConstants.UPDATE_PE_SHORT_INTRO,
                jsonBody: JSON.stringify({
                    editionId: editionId,
                    content: content
                })
            })

            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default UpdateShortIntroduction;